export const LEGAL_COOKIES_HEADING: string = `

<center>
	<h1 style="margin-bottom: 0">Cookie Usage</h1>
	Customizing Your Cookies
</center>

---
`;
